import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18next';
import AvatarEditor from 'react-avatar-editor';
import { Modal, Button } from 'antd';
import { resizeAndConvertToWebp } from '../../../utils/imageUtils';

export default class AvatarCropper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      preview: null,
    };
  }

  setEditorRef(editor) {
    if (editor) this.editor = editor;
  }

  async handleSave() {
    const { image } = this.props;
    const canvas = this.editor.getImageScaledToCanvas();
    
    // Get canvas dimensions
    let {width} = canvas;
    let {height} = canvas;
    
    // Resize to max 500x500 if needed (maintain aspect ratio)
    if (width > 500 || height > 500) {
      const ratio = Math.min(500 / width, 500 / height);
      width = Math.round(width * ratio);
      height = Math.round(height * ratio);
      
      // Create a new canvas with resized dimensions
      const resizedCanvas = document.createElement('canvas');
      resizedCanvas.width = width;
      resizedCanvas.height = height;
      const ctx = resizedCanvas.getContext('2d');
      
      // Use high quality image rendering
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(canvas, 0, 0, width, height);
      
      // Convert to webp
      resizedCanvas.toBlob(
        async (blob) => {
          if (!blob) {
            console.error('Failed to convert image to webp');
            return;
          }
          
          // Create a File object with webp extension
          const fileName = `${image.name.replace(/\.[^/.]+$/, '')  }.webp`;
          const webpFile = new File([blob], fileName, {
            type: 'image/webp',
            lastModified: Date.now(),
          });
          
          this.props.onChangePreview({
            croppedFile: webpFile,
          });
        },
        'image/webp',
        0.85, // Quality: 85%
      );
    } else {
      // If already within 500x500, just convert to webp
      canvas.toBlob(
        async (blob) => {
          if (!blob) {
            console.error('Failed to convert image to webp');
            return;
          }
          
          // Create a File object with webp extension
          const fileName = `${image.name.replace(/\.[^/.]+$/, '')  }.webp`;
          const webpFile = new File([blob], fileName, {
            type: 'image/webp',
            lastModified: Date.now(),
          });
          
          this.props.onChangePreview({
            croppedFile: webpFile,
          });
        },
        'image/webp',
        0.85, // Quality: 85%
      );
    }
  }

  handleScale(e) {
    const scale = parseFloat(e.target.value);
    this.setState({ scale });
  }

  handleXPosition(e) {
    const { position } = this.state;
    const x = parseFloat(e.target.value);
    this.setState({ position: { ...position, x } });
  }

  handleYPosition(e) {
    const { position } = this.state;
    const y = parseFloat(e.target.value);
    this.setState({ position: { ...position, y } });
  }

  handlePositionChange(position) {
    this.setState({ position });
  }

  render() {
    return (
      <div>
        <div className="static-modal">
          <Modal
            visible={this.props.isShowModal}
            onCancel={this.props.onHideModal}
            className="avatar-editor-modal"
            header="Edit Avatar"
            bodyStyle={{ textAlign: 'center' }}
            footer={[
              <Button
                className="btn-fill btn-wd"
                type="primary"
                onClick={() => this.handleSave()}
                key="saveBtn"
              >
                {I18n.t('button.save')}
              </Button>,
            ]}
          >
            <AvatarEditor
              ref={editor => this.setEditorRef(editor)}
              width={250}
              height={250}
              border={50}
              color={[0, 0, 0, 0.6]} // RGBA
              scale={parseFloat(this.state.scale)}
              rotate={0}
              borderRadius={125}
              onPositionChange={p => this.handlePositionChange(p)}
              // onImageChange={() => this.handleSave()}
              image={this.props.image}
            />
            <br />
            Zoom:
            <div className="zoom-div">
              <input
                name="scale"
                type="range"
                onChange={e => this.handleScale(e)}
                min="1"
                max="2"
                step="0.01"
                defaultValue="1"
              />
            </div>
          </Modal>
        </div>
        {!!this.state.preview && (
          <img
            src={this.state.preview.img}
            style={{
              borderRadius: `${(Math.min(this.state.preview.height, this.state.preview.width) +
                10) *
                (this.state.preview.borderRadius / 2 / 100)}px`,
            }}
            alt=""
          />
        )}
      </div>
    );
  }
}

AvatarCropper.propTypes = {
  onChangePreview: PropTypes.func,
  image: PropTypes.object,
  isShowModal: PropTypes.bool,
  onHideModal: PropTypes.func,
};
